export function formatDuration(seconds: number): string {
  const totalMinutes = Math.ceil(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes} min`;
  }
  if (hours > 0) {
    return `${hours} hours`;
  }
  return `${minutes} min`;
}

export const getPrimeVideoSlug = (title: string, fallback: string) => {
  const slug = (title || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return encodeURIComponent(slug || fallback);
};

export const getSlug = (value: string) =>
  (value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
